import { AfterViewInit, Component, ContentChildren, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
    selector: 'cmn-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements AfterViewInit {

    @ContentChildren(MenuItemComponent) childrenQuery: QueryList<MenuItemComponent>;

    @Input() initialState: 'collapsed' | 'expanded' = 'collapsed';
    @Input() collapsibleMenuItems: boolean = true;

    constructor() {
    }

    ngAfterViewInit(): void {
        this.childrenQuery.toArray().forEach((element: MenuItemComponent) => {
            element.initialState = this.initialState;
            element.collapsible = this.collapsibleMenuItems;
        });
    }
}
